import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import TransactionCategoryForm from "../../../Components/Forms/Pages/Finance/TransactionCategory/TransactionCategoryForm";
import DrawerContext from "../../../Context/DrawerContext";
import {
    addTransactionCategory,
    getTransactionCategoryList
} from "../../../Services/Finance/TransactionCategoryService";
import LinearProgress from '@mui/material/LinearProgress';
import SnackbarContext from "../../../Context/SnackbarContext";


const formRules = {
    'name': {required: true}
}

const AddTransactionCategory = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, handleSubmit, getValues, control, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [transactionCategories, setTransactionCategories] = useState(0);

    useEffect(() => {
        setDrawerTitle(strings.pages.finance.transactionCategory.addTransactionCategory.pageTitle);
    });

    useEffect(() => {
        fetch(); 
    },[])

    const fetch = (term = '') => {
        getTransactionCategoryList({term}).then(response => {
            if (!response || !response.ok) {
                return;
            }
            setTransactionCategories(response.data.result);
        })
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        addTransactionCategory(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.addingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <TransactionCategoryForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                control={control}
                onChangeParentFilter={fetch}
                transactionCategories = {transactionCategories}
                errors={errors} data={data} form={form}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default AddTransactionCategory;